import { render, staticRenderFns } from "./quotationGui.vue?vue&type=template&id=2fdc453c&scoped=true&"
import script from "./quotationGui.vue?vue&type=script&lang=js&"
export * from "./quotationGui.vue?vue&type=script&lang=js&"
import style0 from "./quotationGui.vue?vue&type=style&index=0&id=2fdc453c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc453c",
  null
  
)

export default component.exports